import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';

export const DEFAULT_DURATION = 200;

export const collapse = trigger('collapse', [
    state('true', style({ height: AUTO_STYLE, visibility: AUTO_STYLE, opacity: 1 })),
    state('false', style({ height: '0', visibility: 'hidden', opacity: 0, overflow: 'hidden' })),
    transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
    transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
  ]);
